import { RoundedBox } from "@react-three/drei";
import { FACTORY } from "@/components/aiot/lab/FactoryRoom";

const B = ({ s, p, c, r = 0.04, rough = 0.75 }) => (
  <RoundedBox args={s} position={p} radius={r} smoothness={2} castShadow receiveShadow><meshStandardMaterial color={c} roughness={rough} /></RoundedBox>
);

export const HotelRoom = () => (
  <group>
    <mesh rotation={[-Math.PI / 2, 0, 0]} receiveShadow><planeGeometry args={[6, 5]} /><meshStandardMaterial color="#CDBBA0" roughness={0.95} /></mesh>
    <mesh position={[0, 1.5, -2.5]} receiveShadow><boxGeometry args={[6, 3, 0.08]} /><meshStandardMaterial color="#F4EEE4" /></mesh>
    <mesh position={[-3, 1.5, 0]} receiveShadow><boxGeometry args={[0.08, 3, 5]} /><meshStandardMaterial color="#EAE2D4" /></mesh>
    <mesh position={[-2.96, 1.05, 1.75]}><boxGeometry args={[0.04, 2.1, 0.95]} /><meshStandardMaterial color="#7C4A2D" /></mesh>
    <mesh position={[-2.96, 1.05, -1.6]}><boxGeometry args={[0.04, 2.1, 0.8]} /><meshStandardMaterial color="#A47551" /></mesh>
    <mesh position={[-2.95, 1.2, 0.95]}><boxGeometry args={[0.04, 0.16, 0.1]} /><meshStandardMaterial color="#1F2937" /></mesh>
    <mesh position={[-1.45, 0.95, -2.45]}><boxGeometry args={[0.18, 0.12, 0.02]} /><meshStandardMaterial color="#E5E7EB" /></mesh>
    <B s={[2.3, 1.2, 0.1]} p={[0.3, 0.85, -2.43]} c="#6B4226" r={0.03} />
    <B s={[2.0, 0.45, 2.1]} p={[0.3, 0.25, -1.35]} c="#F8FAFC" />
    <B s={[2.04, 0.08, 1.4]} p={[0.3, 0.5, -1.0]} c="#0F766E" r={0.02} />
    <B s={[0.6, 0.14, 0.35]} p={[-0.2, 0.55, -2.1]} c="#FFFFFF" r={0.06} />
    <B s={[0.6, 0.14, 0.35]} p={[0.8, 0.55, -2.1]} c="#FFFFFF" r={0.06} />
    <B s={[0.45, 0.5, 0.4]} p={[-1.15, 0.25, -2.2]} c="#8B5E3C" />
    <B s={[0.45, 0.5, 0.4]} p={[1.75, 0.25, -2.2]} c="#8B5E3C" />
    <B s={[1.1, 0.32, 0.22]} p={[0.9, 2.45, -2.36]} c="#FFFFFF" r={0.06} />
    <mesh position={[2.0, 1.6, -2.45]}><boxGeometry args={[1.2, 1.1, 0.03]} /><meshStandardMaterial color="#BAE6FD" emissive="#7DD3FC" emissiveIntensity={0.25} /></mesh>
    <B s={[0.35, 1.9, 0.06]} p={[1.25, 1.75, -2.38]} c="#B45309" r={0.02} />
    <B s={[0.35, 1.9, 0.06]} p={[2.75, 1.75, -2.38]} c="#B45309" r={0.02} />
    <B s={[1.4, 0.05, 0.22]} p={[2.0, 0.95, -2.38]} c="#E5E7EB" r={0.02} />
    <B s={[1.8, 0.5, 0.45]} p={[0.4, 0.3, 2.05]} c="#5B3A29" />
    <mesh position={[0.4, 1.05, 2.2]}><boxGeometry args={[1.3, 0.75, 0.05]} /><meshStandardMaterial color="#0F172A" roughness={0.3} /></mesh>
    <B s={[0.8, 0.7, 0.8]} p={[2.3, 0.35, 0.8]} c="#475569" r={0.1} />
    <mesh position={[0, 2.98, 0]}><cylinderGeometry args={[0.22, 0.22, 0.03, 24]} /><meshStandardMaterial color="#FEF9C3" /></mesh>
  </group>
);

export const ROOM = {
  factory: FACTORY,
  home: {
    lamp: [-1, 2.8, -0.3], ac: [-2.6, 2.38, -2.7], door: { hinge: [-3.92, 0, 0.4], w: 1 }, fire: [-1.2, 0.55, -0.6], gas: [3.3, 0.15, -2.1],
    valve: [3.7, 0.75, -2.85], sun: [-1.2, 1.6, -2.9], card: null, walk: [[-3.3, 0, 0.9], [-1.5, 0, 0.9]], bed: [-1.2, 0.55, -0.6], siren: [-0.5, 2.7, -1],
    cam: {
      intro: [[7, 6, 7.5], [0, 1, -1]], motion: [[1.2, 2.6, 4.2], [-2.8, 1.1, 0.4]], door_open: [[0.6, 2.4, 4.2], [-3.4, 1.2, 0.8]], temp_28: [[2.5, 2.6, 3.4], [-1.5, 1.2, -2]],
      gas: [[0.6, 2.2, 1.6], [3.2, 0.4, -2.4]], smoke: [[2.8, 3.2, 3.6], [-1.2, 1.4, -0.8]], no_motion_10: [[5.5, 4.5, 5], [-1, 1, -1]], outro: [[0, 8.5, 6], [0, 0.5, -0.8]],
    },
  },
  hotel: {
    lamp: [0, 2.85, 0], ac: [0.9, 2.3, -2.3], door: { hinge: [-2.94, 0, 1.28], w: 0.95 }, fire: [1.6, 0.8, 0.9], gas: null, valve: null, sun: [2.0, 1.6, -2.45],
    card: [-2.93, 1.2, 0.95], walk: [[-2.5, 0, 1.75], [-0.9, 0, 0.6]], bed: [0.3, 0.6, -1.2], siren: [0, 2.7, 0.2],
    cam: {
      intro: [[5.5, 5, 6.2], [0, 1, -0.5]], card_in: [[0.4, 2.2, 3.6], [-2.8, 1.1, 1.1]], card_out: [[0.4, 2.2, 3.6], [-2.8, 1.1, 1.1]], temp_28: [[2.6, 2.4, 2.8], [0.4, 1.4, -2.2]],
      door_open: [[0.8, 2.2, 3.8], [-2.9, 1.1, 1.8]], smoke: [[2.8, 3, 3.2], [0.6, 1.2, -0.4]], time_2300: [[-1.8, 2.4, 1.8], [0.4, 0.6, -1.4]], outro: [[0, 7.5, 5.5], [0, 0.4, -0.3]],
    },
  },
};
